module.exports = __webpack_public_path__ + "img/image_project.227ff985.png";